import { render, staticRenderFns } from "./payments-balances-maintenance.vue?vue&type=template&id=3bb48aba&scoped=true&"
import script from "./payments-balances-maintenance.vue?vue&type=script&lang=js&"
export * from "./payments-balances-maintenance.vue?vue&type=script&lang=js&"
import style0 from "./payments-balances-maintenance.vue?vue&type=style&index=0&id=3bb48aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb48aba",
  null
  
)

export default component.exports